function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYourblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 56 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-381.296,-541.474)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,310.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.348,
    y: 243.44,
    width: 3.018,
    height: 3.017,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,310.103)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.382,
    y: 243.44,
    width: 3.018,
    height: 3.017,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,332.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.45,
    y: 232.226,
    width: 3.018,
    height: 3.016,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,332.532)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.348,
    y: 232.226,
    width: 3.018,
    height: 3.016,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,356.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.348,
    y: 220.343,
    width: 3.018,
    height: 3.017,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,356.297)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.383,
    y: 220.343,
    width: 3.017,
    height: 3.017,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,405.433,550.528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,27.153L0.002,20.077L-6.033,20.077L-6.033,11.879L9.053,11.879L9.053,27.153L9.055,27.153L0,27.153ZM-9.05,8.862L-10.513,8.862C-11.27,8.862 -11.945,9.399 -12.053,10.147C-12.186,11.08 -11.467,11.879 -10.56,11.879L-9.05,11.879L-9.05,20.078L-18.103,20.078L-18.103,-0.002L-3.016,-0.002L-3.016,8.862L-6.033,8.862L-6.033,8.861L-9.05,8.861L-9.05,8.862ZM-15.085,-6.037L-12.067,-6.037L-12.067,-3.019L-15.085,-3.019L-15.085,-6.037ZM12.07,18.102L21.124,18.102L21.124,36.206L24.141,36.206L24.141,18.102L25.651,18.102C26.482,18.102 27.157,17.427 27.157,16.595C27.157,15.761 26.482,15.085 25.65,15.085L12.07,15.085L12.07,11.879L13.532,11.879C14.288,11.879 14.964,11.342 15.071,10.594C15.205,9.661 14.485,8.862 13.579,8.862L0,8.862L0,-0.002L1.465,-0.002C2.221,-0.002 2.897,-0.538 3.004,-1.287C3.138,-2.219 2.418,-3.019 1.51,-3.019L-9.05,-3.019L-9.05,-9.054L-18.103,-9.054L-18.103,-3.02L-22.628,-3.019C-23.535,-3.019 -24.254,-2.219 -24.121,-1.287C-24.014,-0.538 -23.338,-0.002 -22.582,-0.002L-21.12,-0.002L-21.12,20.078L-22.579,20.078C-23.335,20.078 -24.012,20.614 -24.12,21.362C-24.256,22.295 -23.536,23.095 -22.628,23.095L-21.12,23.095L-21.12,36.207L-18.103,36.207L-18.103,23.095L-3.017,23.095L-3.017,36.207L0,36.207L0,30.172L15.088,30.172L15.088,27.05L12.07,27.071L12.07,18.102Z",
    style: {
      fill: "rgb(73,203,162)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,346.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.521,
    y: 225.336,
    width: 3.017,
    height: 3.017,
    style: {
      fill: "rgb(73,203,162)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,394.988,582.355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.562C-1.784,3.562 -3.329,2.861 -4.151,2.261C-4.67,1.882 -4.784,1.153 -4.405,0.633C-4.027,0.116 -3.301,0.001 -2.782,0.376C-2.662,0.461 -0.047,2.273 2.549,0.379C3.069,0 3.798,0.114 4.177,0.633C4.556,1.153 4.442,1.882 3.923,2.261C2.609,3.22 1.246,3.562 0,3.562",
    style: {
      fill: "rgb(73,203,162)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,370.453)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.45,
    y: 213.265,
    width: 15.088,
    height: 3.017,
    style: {
      fill: "rgb(73,203,162)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourblock);
export default __webpack_public_path__ + "static/media/yourblock.9680c427d07fbb27c422f28ce3fb5ab4.svg";
export { ForwardRef as ReactComponent };